import React, { useState, useEffect } from 'react'
// import './login.css'
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import {  useNavigate } from 'react-router-dom';
 import logo from "../../assests/logo.png"
import { handleApi } from "../../utils/authentication"
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {toast} from "react-toastify"
import { CommonModal } from '../../components/CommonModal';


const ClientSetUpPassword = () => {

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const { setup_password_token } = useParams()
  const [passwordDetails, setPasswordDeatils] = useState()
  const [initialValues, setInitialValues] = useState({
    email: '',
    password: '',
    confirm_password: ''
  });
  const [isLoading,setIsLoading]=useState(false)
  const [showModal,setShowModal]=useState(false)
  const [loading,setLoading]=useState(false)
  const [content,setContent]=useState('')

  const navigate = useNavigate()
  const checkIsPasswordSet = async () => {
    try {
      setIsLoading(true)
      if (setup_password_token) {
        let method = "POST"
        let data = JSON.stringify({
          encryptedData: setup_password_token
        })
        let headers = {
          "Content-Type": "application/json"
        }
        let result = await handleApi('user_decrypt_setup_password_data', method, headers, data)

        if (result?.success) {
          setPasswordDeatils({
            token: result?.token,
            is_password_set: result?.is_password_set,
            ...result?.data
          })
          setInitialValues({
            email: result.data.email,
            password: '',
            confirm_password: ''
          });
    
        }
        else {
          toast.error('Given link is expired.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          navigate('/client/login')


        }
      }

    }
    catch (e) {
      console.log(e)

    }finally{
      setIsLoading(false)
    }

  }
  const handleSetUpPassword = async () => {
    try {
      setIsLoading(true)
      let method = "POST"
      let headers = {
        'Content-Type': 'application/json',
        'token': passwordDetails?.token
      }
      let data = JSON.stringify({
        email: formik?.values?.email,
        new_password: formik?.values?.password,
        invitation_id: passwordDetails?.invitation_id,
        accepted_terms_conditions: formik?.values?.accepted_terms_conditions


      })
      let result = await handleApi('user_setup_password', method, headers, data)

      if (result?.success) {
          toast.success('Password Set Successfully.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        navigate('/client/login',{state:{email:formik?.values?.email}})
       }else{
        toast.error(result?.error?.error_message?result?.error?.error_message:"Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

       }

    }
    catch (e) {
      console.log(e)
    }
    finally{
      setIsLoading(false)
    }

  }

  const handleAcceptInvite = async () => {
    try {
      setIsLoading(true)
      let method = "POST"
      let headers = {
        'Content-Type': 'application/json',
        'token': passwordDetails?.token
      }
      let data = JSON.stringify({
        email: formik?.values?.email,
        invitation_id: passwordDetails?.invitation_id,
        is_invite_accepted: 1


      })
      let result = await handleApi('user_invite_accept', method, headers, data)
      if (result?.success) {
        
        toast.success('Invite accepted successfully.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate('/client/login',{state:{email:formik?.values?.email}})

      }else{
        toast.error(result?.error?.error_message?result?.error?.error_message:"Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }

    }
    catch (e) {
      console.log(e)
      toast.error("Something went wrong!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }finally{
      setIsLoading(false)
    }
  }
  useEffect(() => {
    checkIsPasswordSet()

  }, [])

  //formik validtion 
  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Email is Required'),
    password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(16, 'Password must be 16 characters or less')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .required('Password is Required'),
    confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Password does not match').min(8, 'Password must be at least 8 characters').max(16, 'Password must be 16 characters or less').required('Confirm Password'),
    accepted_terms_conditions: Yup.boolean()
    .oneOf([true], "Please accept the terms & conditions to continue")
    .required("Please accept the terms & conditions to continue")
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    accepted_terms_conditions:false,
    onSubmit: (values) => {

      handleSetUpPassword()


    },
  });
  //console.log(formik)


    const getTermsAndConditions=async ()=>{
        try {
            setLoading(true)  // Start loading
            const blob = new Blob([content], { type: 'text/plain;charset=utf-8' }); // Create a Blob from the content
       
            let method = "GET";
            let headers = {};
          
             let result = await handleApi('get_terms_and_conditions', method, headers,);
         
             
            if (result?.success) {
         
              setContent(result?.data?.content)
        
            } else {
              toast.error(result?.error?.error_message?result?.error?.error_message:"Something went wrong! Please Try again later", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
            }
          } catch (e) {
            toast.error(e.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          } finally {
            setLoading(false)  // Stop loading
          }

    }
    useEffect(()=>{
        getTermsAndConditions()

    },[])





  return (
    <>
    <form onSubmit={formik.handleSubmit} className='login_main'>
      <div className="d-flex gap-2 align-items-center mb-5">
              <img src={logo} alt="" className="" style={{width:'3rem',height:'auto'}}/>
              <div className={` logo_heading  d-flex justify-content-center flex-column `} >
                <p style={{fontSize:'1.2rem',lineHeight:"1rem"}} className="mb-0">University </p>
                <p style={{fontSize:'1.2rem',lineHeight:"1rem"}} className="mb-0">Intelligence</p>
              </div>
      </div>

      <div id="login_card">

        <div className="login_container">
          {!passwordDetails?.is_password_set ?
            <p id="login_heading"><span>Setup Password</span></p> : <p id="login_heading"><span>Accept Invite</span></p>}
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input type="email"
              className="form-control input"
              id="email"
              placeholder="Email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              disabled={true}

            />
            {formik.touched.email && formik.errors.email ? (
              <div className='text-danger'>{formik.errors.email}</div>
            ) : null}
          </div>
          {!passwordDetails?.is_password_set ? <>
            <div className="mb-2">
              <label htmlFor="password" className="form-label">Password</label>
              <div className="d-flex justify-content-center align-items-center position-relative">
                <input type={showPassword ? "text" : "password"}
                  className="form-control input"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}

                  id="password" placeholder="Enter your password " />
                <span className=" eye_btn " onClick={() => {
               
                  setShowPassword((prev) => !prev)

                }} >
                  {!showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                </span>

              </div>
              {formik.touched.password && formik.errors.password ? (
                <div className='text-danger'>{formik.errors.password}</div>
              ) : null}

            </div>
            <div className="mb-1">
              <label htmlFor="confirm_password" className="form-label">Confirm Password</label>
              <div className="d-flex justify-content-center align-items-center position-relative">
               
                <input 
                 type={showConfirmPassword ? "text" : "password"}
                  className="form-control input"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirm_password}

                  id="confirm_password" placeholder="Enter your confirm password " />
                  <span className=" eye_btn " onClick={() => {
                    setShowConfirmPassword((prev) => !prev)
                  }} >
                    {!showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                  </span>


              </div>

              




              {formik.touched.confirm_password && formik.errors.confirm_password ? (
                <div className='text-danger'>{formik.errors.confirm_password}</div>
              ) : null}

            </div>
            <div className='mb-4'>
              <div className='d-flex align-items-center gap-2'>
              <input type="checkbox" name="accepted_terms_conditions" id="accepted_terms_conditions"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.accepted_terms_conditions}
              
              
              />
              <label htmlFor="accepted_terms_conditions"  className='form-label' target="_blank" style={{textDecoration:'none'}}>Click on the checkbox to accept the <span style={{textDecoration:'none',cursor:'pointer',color:'var( --primary-color)'}} onClick={()=>setShowModal(true)}> Terms & Condition</span>  of University Intelligence to continue</label>
              </div>
              {/* {  formik.errors.accepted_terms_conditions ? (
                <div className='text-danger'>Please accept the <a style={{textDecoration:'none',color:"var(--primary-color)",cursor:'pointer'}} onClick={()=>setShowModal(true)}>Terms & Conditions</a>  to continue</div>
              ) : null} */}
            
            </div>
        


           
            <button type="submit" disabled={isLoading} className="btn btn-dark  w-100 login_btn d-flex justify-content-center align-items-center gap-2" >
             {isLoading ?"Saving...":"Save"} 
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg></button> </> :

            <button type="button" disabled={isLoading} onClick={handleAcceptInvite} className="btn btn-dark mt-4 w-100 login_btn  d-flex justify-content-center align-items-center" >
               {isLoading ?"Processing...":"Accept Invite "}  
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg></button>
          }
       


        </div>





      </div>

    </form>
    {showModal ?( <CommonModal
             size='xl'
             height="70vh"
              title={
                <>
                  <div className="d-flex flex-column gap-1">
                    <span className="fs-4 fw-bold">Terms And Conditions</span>
                    <small className="fs-8"></small>
                  </div>
                </>
              }
              body={
             <div className='container  '>

            <div  dangerouslySetInnerHTML={{ __html: content }}/>

             </div>
              }
              show={showModal}
              setShow={setShowModal}
            />):(<></>)}
      
    </>



  )
}

export default ClientSetUpPassword